export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'docsdone-theme'

export function getStoredTheme(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'light' || value === 'dark' ? value : null
  } catch {
    return null
  }
}

/**
 * Light is the default — printed paper — and the marketing site agrees, so a
 * customer meets one material either side of the sign-in. Dark is a
 * deliberate choice.
 *
 * The same rule is inlined in index.html so it applies before first paint;
 * change both or the page flashes the wrong material while React boots.
 */
export function resolveTheme(): Theme {
  return getStoredTheme() ?? 'light'
}

export function applyTheme(theme: Theme) {
  // Light is the unstamped default, so choosing it REMOVES the stamp rather
  // than setting one — otherwise the two ways of being light disagree.
  if (theme === 'dark') document.documentElement.dataset.theme = 'dark'
  else delete document.documentElement.dataset.theme
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    /* private browsing — still apply for this session */
  }
}

export function initTheme() {
  applyTheme(resolveTheme())
}

export function toggleTheme(current: Theme): Theme {
  const next = current === 'light' ? 'dark' : 'light'
  applyTheme(next)
  return next
}
